import Amount from '@components/amounts-received/components/amount/amount.component'
import Description from '@components/amounts-received/components/description/description.component'

import './card-amounts-received.component.scoped.scss'

const CardAmountsReceived = () => {
  return (
    <div className="card-amount-received">
      <Amount />
      <Description />
    </div>
  )
}

export default CardAmountsReceived
